import { useParams, Navigate, Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight, Mail } from "lucide-react";
import { PageHero, CTABand, AreaChips } from "../components/ui-kit";
import { Reveal } from "../motion";
import { PARTNERS, PARTNERS_CONTACT, AREAS, MAILTO } from "../content";
import { PHOTOS } from "../assets";

export default function Partner() {
  const { slug } = useParams();
  const p = PARTNERS[slug];
  if (!p) return <Navigate to="/404" replace />;
  const c = PARTNERS_CONTACT[p.key];
  const words = p.name.split(" ");
  const titleLines = [words.slice(0, 2).join(" "), words.slice(2).join(" ")].filter(Boolean);

  return (
    <>
      <PageHero eyebrow={p.role} titleLines={titleLines} lead={p.lead} />
      <section className="bg-bone py-20 lg:py-28">
        <div className="mx-auto max-w-[1400px] px-6 lg:px-10 grid lg:grid-cols-[1.6fr_1fr] gap-14 lg:gap-20">
          <div className="space-y-14">
            {p.sections.map((s, i) => (
              <Reveal key={i} className="border-t border-ink/12 pt-8">
                <h2 className="serif text-2xl lg:text-4xl text-ink mb-5 max-w-2xl">{s.h}</h2>
                <p className="text-ink/70 text-lg leading-relaxed font-light max-w-3xl">{s.p}</p>
              </Reveal>
            ))}
            <div className="grid sm:grid-cols-3 gap-8 border-t border-ink/12 pt-10">
              {p.lists.map((l) => (
                <Reveal key={l.h}>
                  <div className="eyebrow text-gold mb-4">{l.h}</div>
                  <ul className="space-y-3">
                    {l.items.map((it, k) => (
                      <li key={k} className="text-ink/65 text-sm leading-relaxed flex gap-2"><span className="text-gold">—</span> {it}</li>
                    ))}
                  </ul>
                </Reveal>
              ))}
            </div>
          </div>
          <div className="lg:sticky lg:top-28 h-fit space-y-5">
            <Reveal className="bg-ink text-bone rounded-2xl overflow-hidden grain">
              <div className="relative aspect-[4/5] overflow-hidden">
                <img src={PHOTOS[p.key]} alt={`Retrato profissional de ${p.name}`} className="w-full h-full object-cover object-top" />
                <div className="absolute inset-0 bg-gradient-to-t from-ink via-transparent to-transparent" />
              </div>
              <div className="p-8">
                <div className="serif text-2xl mb-1">{p.name}</div>
                <div className="text-gold text-sm mb-6">{p.role}</div>
                <a href={c.wa} target="_blank" rel="noreferrer" data-testid="partner-wa" className="btn-gold w-full justify-center mb-3">Fale pelo WhatsApp <ArrowRight size={16} /></a>
                <a href={MAILTO} data-testid="partner-email" className="flex items-center justify-center gap-2 w-full border border-white/20 rounded-full py-3 text-bone/80 hover:border-gold transition-colors text-sm"><Mail size={15} /> Enviar e-mail</a>
                <a href={c.linkedin} target="_blank" rel="noreferrer" data-testid="partner-linkedin" className="flex items-center justify-center gap-1.5 mt-4 text-gold text-sm hover:underline">LinkedIn <ArrowUpRight size={14} /></a>
              </div>
            </Reveal>
          </div>
        </div>
        <div className="mx-auto max-w-[1400px] px-6 lg:px-10 mt-20 border-t border-ink/12 pt-10">
          <div className="eyebrow text-ink/40 mb-6">Áreas de atuação relacionadas</div>
          <AreaChips slugs={p.areas} areas={AREAS} />
        </div>
      </section>
      <CTABand title={[`Apresente a questão`, `a ${words[0]}.`]} text="Uma descrição inicial do assunto, das pessoas ou empresas envolvidas e de eventual prazo permite compreender o contexto e indicar as informações necessárias." />
    </>
  );
}
